export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};
export const versions: TsAppVersion = {
    version: '1.5.2',
    name: 'okr-frontend',
    versionDate: '2023-03-01T11:42:52.795Z',
};
export default versions;
